export default "__VITE_ASSET__BC0G6mjp__"